import type { EHumanReviewTab } from './human-review-requests.type'
import { parsePositiveInteger } from './human-review-search-params.util'

// Patient ids belong to a project: the memory is per project and per tab
const getStorageKey = (projectId: number, tab: EHumanReviewTab) =>
  `humanReview_lastPatientMedEventId_${projectId}_${tab}`

export const getLastPatientMedEventId = (projectId: number, tab: EHumanReviewTab): number | null =>
  parsePositiveInteger(localStorage.getItem(getStorageKey(projectId, tab)))

export const setLastPatientMedEventId = (
  projectId: number,
  tab: EHumanReviewTab,
  patientMedEventId: number,
) => {
  localStorage.setItem(getStorageKey(projectId, tab), patientMedEventId.toString())
}

// Priority: the patient in the URL, then the last one seen on the tab, then the first of the list
export const pickPatientMedEventId = ({
  listedIds,
  selectedId,
  lastSeenId,
}: {
  listedIds: number[]
  selectedId: number | null
  lastSeenId: number | null
}): number =>
  [selectedId, lastSeenId].find((candidateId) => candidateId && listedIds.includes(candidateId)) ||
  listedIds[0]
